module.exports = __webpack_public_path__ + "static/media/HONGOV_MENU-normal.f1be105a.png";